import type { RestoreJob } from '@repo/api-gw-sdk';
import { CloudProviderIndicator } from '@/components/cloudProviderIndicator';
import { TextDetailsTuple } from '@/components/text/textDetailsTuple';
import { useDAL } from '@/contexts/useDAL';
import { AccountIndicator } from '../accountIndicator';
export const JobRestoreAccountIndicator = ({
  job,
  showCloudIndicator = true,
  showAccountName = true,
  showAccountId = true,
  copyable = true
}: {
  job: RestoreJob;
  showCloudIndicator?: boolean;
  showAccountName?: boolean;
  showAccountId?: boolean;
  copyable?: boolean;
}) => {
  const {
    providerAccountId,
    cloudProvider
  } = job.destinationDetails;
  const dal = useDAL();
  const {
    data: body
  } = dal.cloudAccounts.restore.useList();
  const account = body?.accounts.find(a => a.providerAccountId === providerAccountId);
  if (account) {
    return <AccountIndicator account={account} showCloudIndicator={showCloudIndicator} showAccountName={showAccountName} showAccountId={showAccountId} copyable={copyable} />;
  }
  if (!providerAccountId) {
    return null;
  }
  const tuple = <TextDetailsTuple primaryProp={showAccountName || showAccountId ? providerAccountId : undefined} copyable={copyable} />;
  return showCloudIndicator ? <CloudProviderIndicator cloudProvider={cloudProvider} text={tuple} /> : tuple;
};